<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add New FAQ</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label for="questionEn" class="form-label">Question EN</label>
              <input
                type="text"
                class="form-control"
                id="questionEn"
                v-model="questionEn"
                @change="update('questionEn', questionEn)"
              />

              <label for="questionCh" class="form-label">Question CH</label>
              <input
                type="text"
                class="form-control"
                id="questionCh"
                v-model="questionCh"
                @change="update('questionCh', questionCh)"
              />

              <label for="answerEn" class="form-label">Answer EN</label>
              <textarea
                class="form-control"
                id="answerEn"
                v-model="answerEn"
                @change="update('answerEn', answerEn)"
              />

              <label for="answerCh" class="form-label">Answer CH</label>
              <textarea
                class="form-control"
                id="answerCh"
                v-model="answerCh"
                @change="update('answerCh', answerCh)"
              />
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveChanges">
            Add
          </button>
          <button type="button" class="btn btn-secondary" @click="closeModal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authHeader from "../../services/authHeader";
import axios from "axios";
export default {
  name: "ModalFaq",
  data() {
    return {
      questionEn: "",
      questionCh: "",
      answerCh: "",
      answerEn: "",
      obj: {},
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal-event");
    },

    saveChanges() {
      axios
        .post(this.$webDomain +"/garden/GardenQuestion", this.obj, {
          headers: authHeader(),
        })
        .then(function(response) {
          console.log(response);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
        });

      this.closeModal();
    },
    update(key, value) {
      if (
        key === "questionEn" ||
        key === "questionCh" ||
        key === "answerCh" ||
        key === "answerEn"
      ) {
        this.obj[key] = value;
      }
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
}

.form-label {
  margin-top: 0.5rem;
}

textarea {
  height: 150px;
}
</style>
